<template lang="html">
    <section>
        <h4>GoPro</h4>
        <p>
            Digiworld US, New York’s no.1 online retailer was established in May
            2012 with the aim and vision to become the one-stop shop for retail
            in New York with implementation of best practices both online
        </p>
        <a href="#">More Products from Gopro</a>
    </section>
</template>

<script>
export default {
    name: 'PartialVendor'
};
</script>

<style lang="scss" scoped></style>
